import { useEffect, useState } from "react";

const ProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const percentage = (scrolled / Math.max(1, scrollHeight)) * 100;
      setProgress(percentage);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 h-[4px] bg-gradient-to-r from-primary via-secondary to-primary z-50 transition-all duration-100"
      style={{ 
        width: `${progress}%`,
        boxShadow: "0 0 20px hsl(var(--primary) / 0.9), 0 0 40px hsl(var(--primary) / 0.5)",
        backgroundSize: "200% 100%",
        animation: "shimmer 3s linear infinite"
      }}
    />
  );
};

export default ProgressBar;
